<div class="qrf-container" style="font-size: 13px;">
  <div>
    <h3 class="center">Quote Request Form</h3>
    <h6 class="center">
      If your request involves an urgent tree-related situation — such as a tree on your home, blocking your driveway, or creating an immediate safety concern — please call 614-895-7000 after submitting the form below. An on-call arborist is available 24 hours a day, 7 days a week, and we will prioritize your request.
    </h6>
  </div>

  <form id="quoteForm" #quoteForm="ngForm">
    <span [hidden]="!showMainContent">
      @if (quoteRequest && quoteRequest.customer && quoteRequest.customer.customerComments && !isCustomer) {
        <div style="height: 51px">
          <p-popover #op>
            <app-customer-comment-view-only [customer]="quoteRequest.customer"></app-customer-comment-view-only>
          </p-popover>
          <p-button type="button" label="Company Wide Notes" (click)="op.toggle($event)"></p-button>
          @if (isEditMode() && canSendOnMyWay) {
            <p-button
              severity="info"
              type="button"
              class="ui-button-primary"
              (click)="onMyWay()"
              label="On My Way">
            </p-button>
          }
          @if (isEditMode() && canSendOnMyWay) {
            <div class="fine-print" style="padding-top: 10px; display: inline-block; padding-left: 8px;">
              Last Sent: {{quoteRequest.onMyWaLastSent ? (quoteRequest.onMyWaLastSent | date: 'short') : 'Not Sent'}}
            </div>
          }
        </div>
      }

      @if (isCustomerEditable()) {
        <div>
          <app-customer-dropdown
            [disabled]="!hasQuotePermissions || !isNew || !editable"
            [existingSelectionId]="quoteRequest?.customer?.id"
            [required]="true"
            (customerSelected)="setCustomer($event)"
          ></app-customer-dropdown>
        </div>
      }
      @if (isCustomerEditable()) {
        <div class="center">
          - OR -
        </div>
      }
      @if (allowNewCustomer() && isCustomerEditable()) {
        <div>
          <ng-container>
            <p-button
              type="button"
              severity="primary"
              [disabled]="selectedCustomer || !this.hasQuotePermissions || !this.editable"
              (click)="addNewCustomer()">Add New Customer
            </p-button>
          </ng-container>
        </div>
      }
      <div>
        <!--
        Only the anonymous RFQ pathway can edit customer info here
        Other pathways can only ADD a new customer, cannot edit info beyond that
        -->
        @if (quoteRequest && quoteRequest.customer) {
          <app-contact-info
            [customer]="quoteRequest.customer"
            [canEdit]="isAnon"
            [smallerHeaders]="true"
            [canEditBilling]="false">
          </app-contact-info>
        }
      </div>
      @if (!isCustomer && quoteRequest) {
        <div class="p-grid">
          <div class="p-col-12">
            <div class="rfq-header">
              Is this Quote Request urgent?
            </div>
            <p-radiobutton
                name="isUrgent"
                [value]="true"
                [(ngModel)]="quoteRequest.isUrgent"
                [disabled]="!this.hasQuotePermissions || !this.editable"
                required
                inputId="isUrgentYes"
            >
            </p-radiobutton>
            <label for="isUrgentYes">Yes</label>
            &nbsp;
            <p-radiobutton
                name="isUrgent"
                [value]="false"
                [(ngModel)]="quoteRequest.isUrgent"
                [disabled]="!this.hasQuotePermissions || !this.editable"
                required
                inputId="isUrgentNo"
            >
            </p-radiobutton>
            <label for="isUrgentNo">No</label>
          </div>
          <div class="p-col-12">
            <div class="rfq-header">
              Call to Schedule?
            </div>
            <p-radioButton
              name="isCallAhead"
              [value]="true"
              [label]="'Yes'"
              [(ngModel)]="quoteRequest.callAhead"
              [disabled]="!this.hasQuotePermissions || !this.editable"
              required>
            </p-radioButton>
            <label for="isCallAheadYes">Yes</label>
            &nbsp;
            <p-radioButton
              name="isCallAhead"
              [value]="false"
              [label]="'No'"
              [(ngModel)]="quoteRequest.callAhead"
              [disabled]="!this.hasQuotePermissions || !this.editable"
              required>
            </p-radioButton>
          </div>
        </div>
        <div class="rfq-header" style="width: 100%;">
          Scheduled On: <span *ngIf="quoteRequest.eventStart">{{ quoteRequest.eventStart | date: 'shortDate' }}</span> <span *ngIf="!quoteRequest.eventStart">Not Scheduled</span>
        </div>
        <div class="rfq-header" style="width: 100%;">
          Regional Manager: <span *ngIf="quoteRequest.representative">{{ quoteRequest.representative.fullName }}</span> <span *ngIf="!quoteRequest.representative">Not Assigned</span>
        </div>
      }
      <div>
        <hr [style.margin-top]="quoteRequest?.customer?.customerTypeId != customerTypesEnum.Residential ? '60px' : null"/>
        <div class="p-grid">
          @if (quoteRequest && quoteRequest.customer && quoteRequest.customer.address) {
            <div class="p-col-12">
              <div class="rfq-header">
                Is the mailing address the same location as the tree work you are needing?
              </div>
              @if (quoteRequest) {
                <div class="less-top-no-bottom-padding">
                  @if (quoteRequest) {
                    <p-radiobutton
                      name="addressIsSameAsCustomer"
                      [value]="true"
                      [(ngModel)]="quoteRequest.addressSameAsCustomer"
                      [disabled]="!this.hasQuotePermissions || !this.editable"
                      (ngModelChange)="addressSameAsCustomerToggle()"
                      required
                      >
                    </p-radiobutton>
                    <label>Yes</label>
                  }
                </div>
              }
              @if (quoteRequest) {
                <div class="less-top-no-bottom-padding">
                  @if (quoteRequest) {
                    <p-radiobutton
                      name="addressIsNotSameAsCustomer"
                      [value]="false"
                      [(ngModel)]="quoteRequest.addressSameAsCustomer"
                      [disabled]="!this.hasQuotePermissions || !this.editable"
                      (ngModelChange)="addressSameAsCustomerToggle()"
                      required
                      >
                    </p-radiobutton>
                    <label>No</label>
                  }
                </div>
              }
            </div>
          }
          @if (quoteRequest && !quoteRequest.addressSameAsCustomer) {
            <div class="p-grid ui-fluid">
              <div class="p-col-6">
                <label class="rfq-header">Service Address Line 1</label>
                @if (quoteRequest) {
                  <input
                    class="input"
                    type="text"
                    name="serviceAddress1"
                    pInputText
                    [(ngModel)]="quoteRequest.address.street"
                    required
                    [disabled]="isServiceAddressDisabled()"
                    >
                }
              </div>
              <div class="p-col-6">
                <label class="rfq-header">Service Address Line 2</label>
                @if (quoteRequest) {
                  <input
                    class="input"
                    type="text"
                    name="serviceAddress2"
                    pInputText
                    [(ngModel)]="quoteRequest.address.apartment"
                    [disabled]="isServiceAddressDisabled()"
                    >
                }
              </div>
              <div class="p-col-6">
                <label class="rfq-header">City</label>
                @if (quoteRequest) {
                  <input
                    class="input"
                    type="text"
                    name="serviceCity"
                    pInputText
                    [(ngModel)]="quoteRequest.address.city"
                    required
                    [disabled]="isServiceAddressDisabled()"
                    >
                }
              </div>
              <div class="p-col-6">
                <label class="rfq-header">State</label>
                @if (quoteRequest) {
                  <ng-select                                        
                    class="custom"
                    required
                    [items]="states"
                    placeholder="Select a State"
                    (ngModelChange)="onStateSelect($event)"
                    [selectOnTab]="true"
                    name="serviceState"
                    bindLabel="name"
                    [(ngModel)]="selectedState"
                    [disabled]="isServiceAddressDisabled()"
                  ></ng-select>
                }
              </div>
              <div class="p-col-6">
                <label class="rfq-header">Zip/Postal Code</label>
                @if (quoteRequest) {
                  <input
                    class="input"
                    type="text"
                    name="serviceZip"
                    pInputText
                    [(ngModel)]="quoteRequest.address.zip"
                    (ngModelChange)="quoteOptionChanged()"
                    required
                    maxlength="5"
                    [disabled]="isServiceAddressDisabled()"
                    >
                }
              </div>
            </div>
          }
        </div>
      </div>
      @if (quoteRequest && quoteRequest.customer && quoteRequest.customer.address) {
        <hr />
      }
      <div class="p-grid">
        <div class="p-col-12">
          @if (quoteRequest) {
            <app-services-section [isDisabled]="!editable" [quoteRequest]="quoteRequest"></app-services-section>
          }
        </div>
      </div>

      @if (quoteRequest) {
        <div class="p-grid" style="margin-top: 5px;">
          <div class="p-col-12">
            <div class="rfq-header">Please Describe Need:</div>
            <div class="rfq-subheader">Please be as detailed as possible (Ex: amount/size/location of the tree(s), etc.)</div>
            @if (quoteRequest) {
              <textarea
                class="width100"
                name="description"
                pInputTextarea
                [(ngModel)]="quoteRequest.description"
                [disabled]="!this.hasQuotePermissions || !this.editable"
                [rows]="5"
                required
              ></textarea>
            }
          </div>
        </div>
      }

      <hr />
      @if (quoteRequest) {
        <div>
          <div class="rfq-header" style="margin-bottom: 6px;">What brought you to our site today?</div>
          <div class="p-grid">
            @for (broughtBy of broughtBys; track broughtBy) {
              <div class="p-col-12 less-top-no-bottom-padding">
                @if (quoteRequest) {
                  <p-radiobutton
                    name="broughtBy"
                    [value]="broughtBy.id"
                    [(ngModel)]="quoteRequest.broughtBy.id"
                    [disabled]="!this.hasQuotePermissions || !this.editable"
                    required
                  ></p-radiobutton>
                  <label> {{ broughtBy.name}} </label>
                }
              </div>
            }
            @if (quoteRequest && quoteRequest.broughtBy.id == 9) {
              <div class="p-col-12">
                <div class="rfq-header">If you selected "Other" in previous question, please explain.</div>
                @if (quoteRequest) {
                  <textarea
                    class="width100"
                    name="reason"
                    pInputTextarea
                    [(ngModel)]="quoteRequest.broughtByOtherNote"
                    [disabled]="!this.hasQuotePermissions || !this.editable"
                    [rows]="1"
                    required
                  ></textarea>
                }
              </div>
            }
          </div>
        </div>
      }
      <hr />

      @if (quoteRequest) {
        <app-quote-option-section
          [isDisabled]="!editable"
          [quoteRequest]="quoteRequest"
          (quoteOptionChanged)="quoteOptionChanged()">
        </app-quote-option-section>
      }

      @if (quoteRequest && quoteRequest.quoteRequestType && !showNextButton && showMainContent) {
        <hr />
      }
      @if (!showVirtualSubmit && quoteRequest) {
        <div class="p-grid" [style.display]="quoteRequest && quoteRequest.quoteRequestType && !showNextButton && showMainContent ? 'block' : 'none'">
          <div class="p-col-12">
            <div class="rfq-header">Photo/Document Upload</div>
            <div class="rfq-subheader">You can optionally attach photos or documents.</div>
            <app-blob-manager [angularUpload]="true" [containerName]="'quote-request'" [parentRecordId]="quoteRequest.id" [uploadLabel]="'Document/Photo'" [viewOnly]="!editable"></app-blob-manager>
          </div>
        </div>
      }
    </span>

    @if (!showMainContent) {
      <span>
        <div class="p-col-12">
          <div class="rfq-header">
            Provide Your Video!
          </div>
          <!-- Review the video below -->
        </div>
        <!-- Embedded video -->
        <div class="p-col-12">
          <div class="rfq-header">
            Video Requirements:
          </div>
          <ul>
            <li>Show a full shot of the entire tree that is in need of tree work. Be sure to show the whole height and width.</li>
            <li>Show if there are any power or communication lines within the area.</li>
            <li>Show all structure (buildings, roads, etc.) within the area of the tree.</li>
            <li>Please narrate the video with any specifics you can provide.</li>
            <li>Show the driveway and road access to the property.</li>
            <li>Show and explain any known underground utilities (septic tanks, water lines, etc.).</li>
          </ul>
        </div>
        <div class="p-col-12">
          <app-blob-manager [angularUpload]="true"
            [containerName]="'quote-request'"
            [parentRecordId]="quoteRequest.id"
            [viewOnly]="!editable"
            [accept]="'video/*'"
            [required]="true"
            [buttonText]="'UPLOAD / RECORD VIDEO'"
            [anonymousPossible]="true"
            (doneUploadingEvent)="doneSaving()"
          ></app-blob-manager>
        </div>
      </span>
    }
    <!-- @if (isAnon && quoteRequest && !captchaSuccess) {
      <div style="margin-top: 2em;">
        <re-captcha #captcha name="recaptchaReactive" (resolved)="onRecaptchaResolved($event)"
        siteKey="6LfZXrsZAAAAAPf99RA9WdiaA_h2Elx6Q7kGaf3M"></re-captcha>
      </div>
    }</div> -->

    @if (quoteRequest) {
      <div class="p-grid">
        @if (errorMessage) {
          <div
            class="p-col-12 columnPadding">
            <div class="alert alert-danger" style="margin-top: 8px;">
              {{errorMessage}}
            </div>
          </div>
        }
        <div class="p-col-12 columnPadding" style="display: flex; flex-direction: row-reverse;">
          @if (showNextButton) {
            <p-button
              type="submit"
              severity="success"  
              (click)="save(quoteForm)"
              [disabled]="!this.hasQuotePermissions || !this.editable || saving || quoteForm.invalid"
              [label]="'Next'">
            </p-button>
          }
          @if (showVirtualSubmit) {
            <p-button
              type="submit"
              severity="success"  
              (click)="doneSaving()"
              [disabled]="disableVirtualSubmit()"
              [label]="'Submit'">
            </p-button>
          }
          @if (showScheduleButton) {
            <p-button
              type="submit"
              severity="success"  
              (click)="save(quoteForm)"
              [disabled]="!this.hasQuotePermissions || !this.editable || saving || quoteForm.invalid"
              [label]="'Submit and Schedule'">
            </p-button>
          }
          @if (!showScheduleButton && !showNextButton && !showVirtualSubmit) {
            <p-button
              type="submit"
              severity="success"  
              (click)="save(quoteForm)"
              [disabled]="!this.hasQuotePermissions || !this.editable || saving || quoteForm.invalid"
              [label]="isEditMode() ? 'Save' : 'Submit'">
            </p-button>
          }
          @if (isEditMode() && !showVirtualSubmit) {
            <p-button
              type="button"
              severity="warn"
              (click)="cancel()"
              [label]="editable ? 'Cancel' : 'Back'">
            </p-button>
          }
          @if (isEditMode() && !showVirtualSubmit) {
            <p-button
              type="button"
              severity="danger"
              (click)="delete()"
              [disabled]="disableDelete || !hasDeletePermissions || !this.editable"
              label="Delete">
            </p-button>
          }
          @if (isEditMode() && hasQuotePermissions && canTransform) {
            <p-button
              severity="info"
              type="button"
              (click)="turnToQuote(quoteForm)"
              [disabled]="quoteRequest.quoteRequestType === 'Firmtime' && quoteRequest.paymentStatus !== 'Paid'"
              label="Transform to Quote">
            </p-button>
          }
        </div>
      </div>
    }
  </form>
</div>



<!-- Add New Customer dialog -->
<!-- Only dialogs inside class scrollableDialog get the CSS for scrolling. Only use scrollableDialog if the dialog actually has enough content that
it needs to scroll because it looks weird otherwise. -->
@if (displayCustomerDialog) {
  <div class="scrollableDialog">
    <p-dialog header="Customer Info" [(visible)]="displayCustomerDialog" [modal]="true" [resizable]="false"
      [baseZIndex]="10000" [maximizable]="true" [style]="{'width': '800px'}" [focusOnShow]="false"
      (onHide)="closedCustomerDialog()" [closable]="false" [blockScroll]="true">
      <p-header style="float:right;">
        <a class="ui-dialog-titlebar-icon ui-dialog-titlebar-close ui-corner-all" tabindex="0" role="button" (click)="closedCustomerDialog()" (keydown.enter)="closedCustomerDialog()" (mousedown)="closedCustomerDialog()">
          <span><i class="pi pi-times"></i></span>
        </a>
      </p-header>
      <app-customer-maintenance [isDialog]="true" (timeToClose)="closedCustomerDialog($event)" [customer]="quoteRequest.customer"></app-customer-maintenance>
    </p-dialog>
  </div>
}
